import { ApprovedForRecCell } from './ApprovedForRecCell';

export default ApprovedForRecCell;
